<template>
    <v-card flat tile :height="$root.edit ? (height || 200) : height">
        <div v-if="$root.edit && !height" class="fill-height">
            <div class="d-flex fill-height">
                <v-btn
                    fab
                    small
                    color="zoezi-edit-color"
                    elevation="3"
                    class="z-center-margin"
                    @click.stop="showDialog = true"
                >
                    <v-icon class="zoezi-edit-text-color">mdi-plus</v-icon>
                </v-btn>
            </div>

            <v-dialog v-model="showDialog" max-width="500" scrollable v-if="showDialog">
                <v-card style="overflow-y: auto; min-height: 90vh" width="440px">
                    <v-card-title class="headline zoezi-edit-color">
                        {{$translate('Choose component')}}
                        <v-btn icon @click="showDialog = false" class="ml-auto"><v-icon class="white--text">mdi-close</v-icon></v-btn>
                    </v-card-title>
                    <v-card-text>
                        <component-palette :component="thisComponent" />
                    </v-card-text>
                </v-card>
            </v-dialog>
        </div>
    </v-card>
</template>

<script>
import ComponentPalette from '../components/ComponentPalette.vue'
export default {
    name: 'zoezi-empty',

    zoezi: {
        title: 'Empty',
        icon: 'mdi-card-outline',
        type: 'sf'
    },

    components: {
        ComponentPalette
    },

    computed: {
        thisComponent() {
            return this;
        }
    },

    props: {
        height: {
            title: 'Height',
            type: String,
            fulltype: 'csssize'
        }
    },

    data: () => ({
        showDialog: false
    })
}
</script>
